import React from "react";
import { Button } from '@mui/material';
import { DialogContent, Dialog, DialogTitle, DialogActions, DialogContentText, Slide } from '@mui/material';
import { CheckCircle as SuccessIcon } from '@mui/icons-material'
import { STAKEHOLDER_SIGN_UP_URL } from "../URLs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const SuccessPopover = (props) => {
    return (
        <Dialog maxWidth='xs' fullWidth open={props.onOpen} TransitionComponent={Transition}>
            <DialogTitle sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                <SuccessIcon sx={{ fontSize: 60, color: "#64dd17" }} />
                {props.message}
            </DialogTitle>
            <DialogContent />
            <DialogActions>
                <Button onClick={props.onClose} >Close</Button>
                {!props.showSignupLink && <a href="/"><Button >Go to home page</Button></a>}
                {props.showSignupLink && <a href={STAKEHOLDER_SIGN_UP_URL + "&lang=" + localStorage.getItem("i18nextLng") + "&urn=" + props.urn}><Button >Go to signUp page</Button></a>}
            </DialogActions>
        </Dialog>
    );
};
